import { render, staticRenderFns } from "./listPastInvoices.vue?vue&type=template&id=3c4e6d29&"
import script from "./listPastInvoices.vue?vue&type=script&lang=js&"
export * from "./listPastInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports